import { Injectable } from "@angular/core";

export interface QueryResult {
  id: number;
  description: string;
  partNumber: string;
  productName: string;
  hasDrawing: boolean;
}


// base implementations for how to convert.
// If these change, make a prototype instead of changing the base implementation
@Injectable()
export class PressureUnitOfMeasureConverter {
  fromBarToPSI(pressure: number) {
    return (pressure * 14.5037738).toFixed(2);
  }

  fromKpaToPSI(pressure: number) {
    return (pressure * .145038).toFixed(2);
  }

  fromkgcm2ToPSI(pressure: number) {
    return (pressure * 14.2233).toFixed(2);
  }
}
